import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, Building2, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { IMG } from "@/lib/constants";

export default function ChoosePath() {
  const nav = useNavigate();
  const { setAccountType } = useAuth();

  const choose = async (type) => {
    await setAccountType(type);
    nav(type === "homeowner" ? "/onboarding/profile" : "/onboarding/business");
  };

  return (
    <div className="min-h-screen bg-sp-navy text-white flex flex-col items-center justify-center p-6 sp-blueprint">
      <div className="mb-10"><Logo dark /></div>
      <h1 className="text-3xl lg:text-4xl font-bold text-center">How do you want to build?</h1>
      <p className="text-white/60 mt-3 text-center">Choose your workspace. You can add the other later.</p>
      <div className="mt-12 grid sm:grid-cols-2 gap-6 max-w-3xl w-full">
        <button data-testid="choose-homeowner" onClick={() => choose("homeowner")}
          className="group text-left rounded-2xl overflow-hidden border border-white/10 sp-hover-card">
          <div className="h-40 relative"><img src={IMG.villaDusk} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-sp-navy/40" /></div>
          <div className="p-6 bg-sp-card">
            <Home className="h-7 w-7 text-sp-orange mb-3" />
            <div className="text-xl font-bold">Build My Home</div>
            <p className="text-sm text-white/60 mt-1">For homeowners planning or building their home.</p>
            <span className="mt-4 inline-flex items-center text-sp-orange text-sm font-medium">Continue <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
          </div>
        </button>
        <button data-testid="choose-business" onClick={() => choose("business")}
          className="group text-left rounded-2xl overflow-hidden border border-white/10 sp-hover-card">
          <div className="h-40 relative"><img src={IMG.cranesSkyline} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-sp-navy/40" /></div>
          <div className="p-6 bg-sp-card">
            <Building2 className="h-7 w-7 text-sp-orange mb-3" />
            <div className="text-xl font-bold">Run My Construction Business</div>
            <p className="text-sm text-white/60 mt-1">For contractors, builders, architects and developers.</p>
            <span className="mt-4 inline-flex items-center text-sp-orange text-sm font-medium">Continue <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
          </div>
        </button>
      </div>
    </div>
  );
}
